/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsSetOrgPrice } from "../../funcs/llmModelsSetOrgPrice.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.SetOrgPriceRequest$inboundSchema,
};

export const tool$llmModelsSetOrgPrice: ToolDefinition<typeof args> = {
  name: "llm-models-set-org-price",
  description: `Set an org price override

Upserts a dated per-org price. Cluster lineage falls back to the cluster default; BYO and serving lineage become unpriced when no org row exists.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsSetOrgPrice(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
